import { Flex, FlexProps } from '@chakra-ui/react';
import ParameterEditListItem from 'components/productManager/ParameterEditListItem';

const SubTitle = (props: FlexProps) => <Flex flex={1} textTransform="uppercase" justifyContent="center" {...props} />;

const defaultBooleanValues = (parameter: any, modelKey: string) => {
  let currentValue = parameter[modelKey];
  if (!currentValue && parameter.type === 'boolean') {
    currentValue = [
      { displayName: '', value: true },
      { displayName: '', value: false },
    ];
  } else if (!currentValue) {
    currentValue = [{ displayName: '', value: '' }];
  }
  return currentValue;
};

const ParameterInputList = ({ parameter, modelKey, paramKey, deleteListItem, onListItemChange }: any) => {
  const inputs = parameter[modelKey] || defaultBooleanValues(parameter, modelKey);
  const transformedValue =
    inputs && typeof inputs === 'object' && !Array.isArray(inputs) ? (Object.values(inputs) as string[]) : inputs;
  const renderValues = Object.entries(transformedValue).map(([inputKey, inputValue]: [string, unknown]) => (
    <ParameterEditListItem
      valueKey={modelKey.toString()}
      paramKey={paramKey}
      item={inputValue as { [key: string]: string }}
      key={`${modelKey}-${inputKey}`}
      inKey={inputKey}
      parameter={parameter}
      deleteListItem={deleteListItem}
      onExpressionChange={onListItemChange}
    />
  ));

  return (
    <Flex flex={1} flexDir="column">
      <Flex flex={1} flexDir="row" justifyContent="space-around">
        <SubTitle>DISPLAY NAME</SubTitle>
        <SubTitle>VALUE</SubTitle>
      </Flex>

      {renderValues}
    </Flex>
  );
};

export default ParameterInputList;
